import { getEnv } from 'env/env';

export const ONE_TRUST_APPLICATION_ID = getEnv(
  'NEXT_PUBLIC_ONE_TRUST_APPLICATION_ID',
);
